var $ = jQuery.noConflict ();

jQuery (document).ready (function (){

    var initializeBlock = function ($block){

        let squareBox = $ ('.block.square-with-slider .square-box')
        let content = $ ('.block.square-with-slider .content')
        let nextBtn = $ ('.block.square-with-slider .btn-prev-next.next')
        let prevBtn = $ ('.block.square-with-slider .btn-prev-next.prev')

        squareBox.on ('change', function (){
            let id = $ (this).data ('id')

            squareBox.removeClass ('active')
            $ (this).addClass ('active')

            content.removeClass ('active')
            $ (`.block.square-with-slider .content[data-id="${id}"]`).addClass ('active')
        })

        squareBox.on ('click touchstart', function (){

            $ (this).trigger ('change');

        })

        nextBtn.on ('click', function (){
            let activeBox = $ ('.block.square-with-slider .square-box.active');

            if (activeBox.hasClass ('last')) {

                $ ('.square-box.first').trigger ('change');

            } else {
                activeBox.next ('.square-box').trigger ('change');
            }

        })
        prevBtn.on ('click', function (){
            let activeBox = $ ('.block.square-with-slider .square-box.active');

            if (activeBox.hasClass ('first')) {

                $ ('.square-box.last').trigger ('change');

            } else {
                activeBox.prev ('.square-box').trigger ('change');
            }

        })

    };

    window.onload = function (){
        initializeBlock ($ (this));
    } ();


    if (window.acf) {
        window.acf.addAction ('render_block_preview/type=square-with-slider', initializeBlock);
    }

});